import React from 'react';

import clsx from 'clsx';
import GlobalFilter from 'components/GlobalFilter';
import { lighten } from '@mui/material'
import PropTypes from 'prop-types';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material';

const StyledToolbar = styled(Toolbar)`
  padding: 0;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const TableToolbar = props => {
  const {
    numSelected,
    preGlobalFilteredRows,
    setGlobalFilter,
    globalFilter,
    total,
    SelectedActions,
    notSearched
  } = props;
  return (
    <StyledToolbar sx={{
      display: 'flex',
      flexWrap: 'wrap',
      fontSize: '14px',
      padding: '0'
    }}
    >
      {notSearched ? (
        <Typography
          style={{ color: '#1779ba' }}
          sx={{
            flex: '1',
            maxWidth: '515px',
            marginRight: '10px',
            fontSize: '14px'
          }}
          variant="h6"
          id="tableTitle"
        >
          Enter your search parameters and click Search to return data by
          default.
        </Typography>
      ) : numSelected > 0 ? (
        <Typography sx={{
          flex: '1',
          maxWidth: '515px',
          marginRight: '10px',
          fontSize: '14px'
        }} variant="h6" id="tableTitle">
          Selected {numSelected}
        </Typography>
      ) : (
        <Typography sx={{
          flex: '1',
          maxWidth: '515px',
          marginRight: '10px',
          fontSize: '14px'
        }} variant="h6" id="tableTitle">
          {total} records found from your search criteria.
        </Typography>
      )}
      <div style={{ display: 'flex', gap: '10px' }}>
        <GlobalFilter
          sx={{
    height: '45px',
    fontSize: '14px'
  }}
          preGlobalFilteredRows={preGlobalFilteredRows}
          globalFilter={globalFilter}
          setGlobalFilter={setGlobalFilter}
        />
        <SelectedActions
          sx={{
    height: '45px'
  }}
          disableActions={numSelected < 1}
          disableExport={total < 1}
        />
      </div>
    </StyledToolbar>
  );
};

TableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
  setGlobalFilter: PropTypes.func.isRequired,
  preGlobalFilteredRows: PropTypes.array.isRequired,
  globalFilter: PropTypes.string.isRequired
};

export default TableToolbar;
